import { isNotSet, isSet, Unset } from '@utils';

import { TableName } from './table';
import { TableColumns } from './table-columns';

export type ColumnName = string;
export type FullColumnName = `${TableName}.${ColumnName}`;

export interface Column {
  name: ColumnName;
  table: TableName;
  sourceType: Column.SourceType;
}

export namespace Column {
  export enum SourceType {
    Boolean = 'boolean',
    Date = 'date',
    Double = 'double',
    Float = 'float',
    Integer = 'int',
    BigInteger = 'bigint',
    Long = 'long',
    Short = 'short',
    String = 'string',
    Struct = 'struct',
    Timestamp = 'timestamp',
    VectorUDT = 'vectorUDT',
  }

  export function isTypeOf(x: any): x is Column {
    return isSet(x.name) && isSet(x.table) && isSet(x.type);
  }

  export function fromFullName(
    fullName: FullColumnName,
    tableColumns: TableColumns
  ): Column | Unset {
    const { name, table } = FullColumnName.destruct(fullName);
    const column =
      table && name
        ? tableColumns[table].find(col => col.name === name)
        : undefined;
    return column ? column : undefined;
  }
}

export namespace FullColumnName {
  export function destruct(fullName: FullColumnName | Unset) {
    if (isNotSet(fullName)) {
      return {
        table: undefined,
        name: undefined,
      };
    }
    const [table, name] = fullName.split('.');
    return {
      table,
      name,
    };
  }

  export function create(props: {
    table: TableName;
    name: ColumnName;
  }): FullColumnName {
    return `${props.table}.${props.name}`;
  }
}
